import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getapplyvendors: option =>
    request('v1/vendor/getapplyvendors', option, true, false), // 获取申请企业备案列表
  getvendors: option => request('v1/vendor/getvendors', option, true, false), // 获取合作企业列表
  getapplyvendor: option => {
    const urls = querystring(option)
    return request('v1/vendor/getapplyvendor' + urls, {}, true, false) // 获取申请企业信息
  },
  auditvendor: option => request('v1/vendor/auditvendor', option, true, false), // 申请企业审核
  updatevendor: option =>
    request('v1/vendor/updatevendor', option, true, false), // 更新企业
  applyvendor: option => request('v1/vendor/applyvendor', option, false, false), // 企业注册申请
  getvendor: option => {
    const urls = querystring(option)
    return request('v1/vendor/getvendor' + urls, {}, true, false) // 获取企业备案信息
  },

  getvendorcodingtypes: option => {
    const urls = querystring(option)
    return request('v1/vendor/getvendorcodingtypes' + urls, {}, true, false) // 查询企业支持的赋码方式
  },
  getvendortagtypes: option => {
    const urls = querystring(option)
    return request('v1/vendor/getvendortagtypes' + urls, {}, true, false) // 查询企业支持的标签类型
  },
  getvendortradetypes: option => {
    const urls = querystring(option)
    return request('v1/vendor/getvendortradetypes' + urls, {}, true, false) // 查询企业支持的贸易类型
  },
  getvendorregulators: option => {
    const urls = querystring(option)
    return request('v1/vendor/getvendorregulators' + urls, {}, true, false) // 查询企业的监管机构
  },
  getvendorcategorys: option => {
    const urls = querystring(option)
    return request('v1/vendor/getvendorcategorys' + urls, {}, true, false) // 查询企业的行业类别
  },
  getappinfo: option => {
    const urls = querystring(option)
    return request('v1/vendor/getappinfo' + urls, {}, true, false) // 查询企业app接入信息
  },
  resetappkey: option => {
    const urls = querystring(option)
    return request('v1/vendor/resetappkey' + urls, {}, true, false) // 重置企业app key
  },
  setappinfo: option => request('v1/vendor/setappinfo ', option, true, false), // 设置企业app接入信息
  getallexpresses: option => request('v1/logistics/getallexpresses', option, true, false), // 物流公司
  getexpresses: option => request('v1/logistics/getexpresses', option, true, false), // 快递模板
  setvendorexpress: option => request('v1/logistics/setvendorexpress', option, true, false), // 快递模板
  getcustomers: option => request('v1/customer/getcustomers', option, true, false), // 客户信息
  getdepartments: option => request('v1/department/getdepartments', option, true, false), // 部门信息
  getdepartmentstaffs: option => request('v1/department/getdepartmentstaffs', option, true, false), // 部门信息
  updatecustomer: option => request('v1/customer/updatecustomer', option, true, false), // 客户信息
  getdeliverytrace: option => request('v1/logistics/getdeliverytrace' + querystring(option), option, true, false) // 物流轨迹
}
